import constants from '../global/constants'

export default {
  methods: {
    /**
     * A thread safe method to store a key:value pair in the local storage
     * of the browser
     * @param {storage key} key 
     * @param {value} value 
     * @returns 
     */
    async setStorage(key, value) {
      return new Promise((resolve) => {
        try {
          localStorage.setItem(key, value)
          resolve();
        } catch (error) {
          console.error('Failed to add to storage: ', error)
          throw error
        }
      })
    },
    getStorage(key) {
      try {
        const value = localStorage.getItem(key)
        return value
      } catch (error) {
        console.error('Could not get key from storage ', error)
        throw error
      }
    },
    delStorage(key) {
      try {
        localStorage.removeItem(key)
      } catch (error) {
        console.error('Could not get key from storage ', error)
      }
    },
    cleanupStorage() {
      for (const key in constants.storageKeys) {
        this.delStorage(constants.storageKeys[key])
      }
    },
    getTokenFromStorage() {
      return this.getStorage(constants.storageKeys.AccessToken)
    },
  },
}